import * as Khan from './khan';
import * as Projects from './projects';

export { Khan, Projects };
